// ---- Percentage-driven pricing (variant % above base, cost % below list) ----
// Shared by the single-product editor (Admin.jsx) and the bulk grid
// (BulkProductEditor.jsx) so both behave identically.
export const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;
export const hasPct = (v) => v !== '' && v !== null && v !== undefined && !Number.isNaN(Number(v));

// Charm endings for auto-calculated selling prices: nearest whole then .99/.95.
export const applyEnding = (value, ending) => {
  if (Number.isNaN(Number(value))) return value;
  const n = Number(value);
  if (ending === '99') return Math.max(0.99, Math.round(n) - 0.01);
  if (ending === '95') return Math.max(0.95, Math.round(n) - 0.05);
  return round2(n);
};

// Pure: given a product, derive variant prices (from base + upliftPct) and costs
// (from costPct), respecting manual overrides. Base = variant[0].price if variants
// exist, else the product's own price.
export const recalcPricing = (e) => {
  if (!e) return e;
  const next = { ...e };
  let variants = e.variants ? e.variants.map((v) => ({ ...v })) : e.variants;
  const base = variants && variants.length ? (Number(variants[0]?.price) || 0) : (Number(e.price) || 0);
  if (variants && variants.length) {
    variants = variants.map((v, i) => (i > 0 && hasPct(v.upliftPct)
      ? { ...v, price: applyEnding(base * (1 + Number(v.upliftPct) / 100), e.priceEnding) }
      : v));
  }
  if (variants) next.variants = variants;
  if (hasPct(e.costPct)) {
    const factor = 1 - Number(e.costPct) / 100;
    if (!e.costManual && (e.price || e.price === 0)) next.cost = round2((Number(e.price) || 0) * factor);
    if (next.variants && next.variants.length) {
      next.variants = next.variants.map((v) => (v.costManual || !(v.price || v.price === 0)
        ? v
        : { ...v, cost: round2((Number(v.price) || 0) * factor) }));
    }
  }
  return next;
};
